import {Injectable} from '@angular/core';
import {ComponentBase} from '../../component-base';
import {StageService} from '../../services/stage.service';
import {SceneUtilsService} from '../../services/scene-utils.service';
import {HelperLinesService} from '../../services/helper-lines.service';
import {BuildFloorService} from '../../services/build-floor.service';
import {CameraService} from '../../services/camera.service';
import {SizeHelperService} from '../../services/size-helper.service';
import {DeckHeightService} from '../../services/deck-height.service';
import {RailingGenerationService} from '../../services/railing/services/railing-generation.service';
import {Select3dService} from '../../services/select-3d.service';
import {EventLogService, Actions} from '../../services/eventLog';
import {AutoScaleSprite} from '../../custom/AutoScaleSprite';
import {FloorHull} from '../../custom/FloorHull';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';

declare let THREE: any;

@Injectable()
export class MoveCornerService extends ComponentBase {

  private oldPoints: Array<any>;
  private spriteMap;
  private sprites: Array<AutoScaleSprite> = [];
  private currentlyMovingPoint: AutoScaleSprite | null;
  private pointsExceptDragged = [];
  private newPosition = new THREE.Vector3();
  private currentlyMovingPointIndex: number;
  private currentFloor;
  private raycaster = new THREE.Raycaster();
  private plane = new THREE.Plane();
  private floorHull: FloorHull;

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private helperLines: HelperLinesService,
    private camera: CameraService,
    private deckHeight: DeckHeightService,
    private sizeHelper: SizeHelperService,
    private railingGeneration: RailingGenerationService,
    private buildFloorSrvc: BuildFloorService,
    private select3dService: Select3dService,
    private eventLog: EventLogService,
    private loadingSpinnerService: LoadingSpinnerService
  ) {
    super();
    this.disable();
    this.spriteMap = new THREE.TextureLoader().load('../../../assets/images/sprites/size_free.png');
  }

  drawSprites() {
    const floor = this.select3dService.getSelectedTier();

    const points = floor.userData.points;
    floor.parent.updateMatrixWorld();

    const pos = new THREE.Vector3();
    floor.getWorldPosition(pos);
    const height = pos.y;

    for (let i = 0; i < points.length; i++) {
      if (!points[i].superstructureType && !points[(i - 1) < 0 ? points.length - 1 : (i - 1)].superstructureType) {

        const spriteMaterial = new THREE.SpriteMaterial({
          map: this.spriteMap,
          color: 0xffffff,
          depthWrite: false,
          depthTest: false,
        });

        const sprite = new AutoScaleSprite(20, 20, spriteMaterial);
        sprite.userData.point = points[i];
        sprite.userData.pointIndex = i;
        sprite.position.set(points[i].x, height, points[i].y);

        this.sprites.push(sprite);
        this.stage.add(sprite);
      }
    }
    const pts = points.map(p => new THREE.Vector3(p.x, height, p.y));
    this.floorHull = new FloorHull(pts);
    this.stage.add(this.floorHull);
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites.length = 0;
    if (this.floorHull) {
      this.stage.remove(this.floorHull);
      this.floorHull = null;
    }
  }

  mouseDown(e: MouseEvent) {
    console.log('mouseDown');
    this.stage.addMany(this.helperLines.getLines());

    this.sceneUtils.getRay(e.offsetX, e.offsetY, this.raycaster);

    this.currentFloor = this.select3dService.getSelectedTier();

    const intersection = this.raycaster.intersectObjects(this.sprites);

    if (intersection.length !== 0) {
      const sprite = intersection[0].object;
      this.currentlyMovingPoint = sprite;
      this.currentlyMovingPointIndex = sprite.userData.pointIndex;
      this.plane.setFromNormalAndCoplanarPoint(new THREE.Vector3(0, 1, 0), sprite.position.clone());
    }

    if (this.currentlyMovingPoint) {
      const points = this.currentFloor.userData.points;
      this.oldPoints = points.map(p => ({...p}));

      this.pointsExceptDragged = points.filter((p, index) => index !== this.currentlyMovingPointIndex);

      for (let i = 0; i < this.pointsExceptDragged.length; i++) {
        this.pointsExceptDragged[i].z = this.pointsExceptDragged[i].y;
      }
      return false;
    }
  }

  mouseMove(e: MouseEvent) {

    if (this.currentlyMovingPoint) {
      e.stopPropagation();

      this.sceneUtils.getRay(e.offsetX, e.offsetY, this.raycaster);

      const hasIntersection = this.raycaster.ray.intersectPlane(this.plane, this.newPosition);

      if (!hasIntersection) {
        return;
      }

      const y = this.newPosition.y;
      const currentlyMovingPointPosition = this.currentlyMovingPoint.position;
      const intersectionPoint = this.helperLines.test(this.newPosition, this.pointsExceptDragged);
      this.newPosition = intersectionPoint || this.newPosition;

      currentlyMovingPointPosition.set(this.newPosition.x, y, this.newPosition.z);

      this.floorHull.movePoint(this.currentlyMovingPointIndex, currentlyMovingPointPosition);
      return false;
    }
  }

  mouseUp() {
    if (this.currentlyMovingPoint) {
      const floor = this.currentFloor;
      const points = floor.userData.points;
      const movedPoint = points[this.currentlyMovingPointIndex];
      movedPoint.x = this.newPosition.x;
      movedPoint.y = this.newPosition.z;

      this.loadingSpinnerService.spinnerLoadingListAddPromise('rebuildFloor').then(_ => {
        this.eventLog.dispatch(new Actions.EditFloorShapeAction(this.oldPoints, points, floor.id));
        this.loadingSpinnerService.spinnerLoadingListRemove('rebuildFloor');
      });

      this.stage.removeMany(this.helperLines.getLines());
      this.currentFloor = null;
      this.currentlyMovingPoint = null;
      return false;
    }
  }

  disable() {
    this.removeSprites();
    super.disable();
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/2D/move-corner.service.ts